import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { AppConfigService, AppConfig } from '../services/app-config.service';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ContentService implements OnInit {

    public appConfig: AppConfig = new AppConfig();

  constructor(private http: HttpClient,
    private appConfigService: AppConfigService,
    private authService: AuthService) {
      this.appConfig = this.appConfigService.getConfig();
    }

    ngOnInit(): void { } 

    //-----------------------------------------------------------
    // getProcedureProtocols - begin
    //-----------------------------------------------------------
    getProcedureProtocols(orgId: string): Observable<any> {

      let url: string = this.appConfig.oc_api_url + environment.oc_api_procedure_protocols_url;

        if (environment.debug_mode) {
            console.log("getProcedureProtocols url: " + url);
        }

        return this.http.get(url);

    }
    //-----------------------------------------------------------
    // getProcedureProtocols - end
    //-----------------------------------------------------------   

}
